import { CheckCircle2, Info } from 'lucide-react';
import styles from './ui.module.css';

export interface ToastMessage {
  id: number;
  message: string;
  kind?: 'success' | 'info';
}

export function ToastRegion({ messages }: { messages: ToastMessage[] }) {
  return (
    <div className={styles.toastRegion} aria-live="polite" aria-atomic="true">
      {messages.map((toast) => {
        const Icon = toast.kind === 'success' ? CheckCircle2 : Info;
        return (
          <div className={styles.toast} role="status" key={toast.id}>
            <Icon
              size={16}
              strokeWidth={1.8}
              color={toast.kind === 'success' ? 'var(--im-success)' : 'var(--im-accent)'}
              aria-hidden="true"
            />
            {toast.message}
          </div>
        );
      })}
    </div>
  );
}
